<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <label class="label-required">เลขที่ใบเบิกสินค้า :</label>
                <div class="row">
                  <div class="col-6">
                    <input
                      id="refCode"
                      name="refCode"
                      v-model="refCode"
                      type="text"
                      maxlength="20"
                      class="form-control"
                      placeholder="เลขที่ใบเบิกสินค้า"
                      :disabled="isReferenceCodeLocked"
                    />
                  </div>
                  <div class="col-6">
                    <button
                      type="button"
                      class="btn btn-sm btn-dark mt-1"
                      @click.prevent="isReferenceCodeLocked ? editReferenceCode() : getMaterial()"
                    >
                      <i :class="isReferenceCodeLocked ? 'fa fa-edit' : 'fa fa-plus-circle'"></i>
                      {{ isReferenceCodeLocked ? 'เปลี่ยนเลขที่ใบเบิกสินค้า' : 'ดึงรายการอะไหล่' }}
                    </button>
                  </div>
                </div>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">รายการอะไหล่รับเข้า:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="30%">รายการอะไหล่</th>
                        <th class="text-center" width="15%">จำนวน</th>
                        <th class="text-center" width="15%">หน่วย</th>
                        <th class="text-center" width="35%">หมายเหตุ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="recvitems == null || recvitems.length == 0">
                        <td colspan="9" class="text-muted text-center">
                          กรุณาดึงข้อมูลรายการอะไหล่
                        </td>
                      </tr>
                      <tr v-for="(item, i) in recvitems" :key="item.QiJobItemId">
                        <td class="text-center"><span class="form-control form-control-plaintext">{{ i + 1 }}</span></td>
                        <td class="form-group">
                          <select2
                            class="form-control text-right"
                            :select2-options="getMaterialCodeOptions(i)"
                            @selectChange="onMaterialCodeChange(i)"
                            v-model="item.MaterialCode"
                            :ref="`materialSelect2-${i}`"
                          ></select2>
                          <span class="form-text text-danger">{{ errors[i] && errors[i].materialCode ? errors[i].materialCode : '' }}</span>
                        </td>
                        <td class="form-group">
                          <input
                            type="number"
                            v-model="item.Quantity"
                            class="form-control text-right"
                            min="0"
                            placeholder="จำนวน"
                            :ref="`quantity-${i}`"
                            @input="onInputChange(i, 'quantity')"
                          />
                          <span class="form-text text-danger">{{ errors[i] && errors[i].quantity ? errors[i].quantity : '' }}</span>
                        </td>
                        <td>
                          <input
                            type="text"
                            v-model="item.UnitName"
                            class="form-control text-center"
                            placeholder="หน่วย"
                            readonly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            v-model="item.Remark"
                            class="form-control"
                            placeholder="หมายเหตุ"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import datepicker from "../../Shared/Datepicker";
import select2 from "../../Shared/Select2";

export default {
  components: {
    select2,
    datepicker,
  },
  data() {
    return {
      refCode: null,
      recvitems: [],
      isReferenceCodeLocked: false,
      originalOptions: [],
      odcMaterialCodeOptions: {},
      errors: []
    };
  },
  methods: {
    validateItems() {
      let isValid = true;
      this.errors = []; // รีเซ็ตข้อผิดพลาด

      this.recvitems.forEach((item, index) => {
        // ตรวจสอบ MaterialCode
        if (!item.MaterialCode) {
          isValid = false;
          this.$set(this.errors, index, { ...this.errors[index], materialCode: 'กรุณาเลือกสินค้า' });
        } else {
          this.$set(this.errors, index, { ...this.errors[index], materialCode: '' });
        }
        // ตรวจสอบ Quantity
        if (!item.Quantity || item.Quantity <= 0) {
          isValid = false;
          this.$set(this.errors, index, { ...this.errors[index], quantity: 'กรุณากรอกจำนวน' });
        } else {
          this.$set(this.errors, index, { ...this.errors[index], quantity: '' });
        }
      });

      return isValid;
    },
    onInputChange(index, field) {
      if (field === 'quantity') {
        if (this.recvitems[index].Quantity && this.recvitems[index].Quantity > 0) {
          this.$set(this.errors, index, { ...this.errors[index], quantity: '' });
        }
      }
    },
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (!this.validateItems()) {
        return false;
      }

      if (self.refCode == "" || self.refCode == null) {
        Swal.fire(
          "",
          "กรุณากรอก เลขที่ใบเบิกสินค้า",
          "warning"
        );
        return false;
      }

      if (self.recvitems.length == 0) {
        Swal.fire(
          "",
          "กรุณาดึงข้อมูลรายการอะไหล่",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/AddReceive",
        data: {
          refCode: this.refCode,
          QIJobItems: this.recvitems,
        },
      })
      .then(function(response) {
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(
            function() {
              router.go(-1), self.$parent.reloadDataTable(false);
            }
          );
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    },
    getMaterial() {
      let self = this;
      if (!self.refCode) {
        Swal.fire("", "กรุณากรอก เลขที่ใบเบิกสินค้า", "warning");
        return false;
      }

      axios.post("/Api/QIJobs/ProductBorrow", {
        RequestDocNo: self.refCode,
      })
      .then((response) => {
        if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
          self.recvitems = response.data.map(item => ({
            QIJobItemId: Date.now(),
            MaterialCode: item.materialCode,
            MaterialName: item.materialNameShow,
            Quantity: item.quantity,
            UnitName: item.baseUnit,
            UnitPrice: item.unitPrice,
            Remark: item.remark || '',
          }));
          self.isReferenceCodeLocked = true;
        } else if (response.data.message) {
          Swal.fire("", response.data.message, "warning");
        } else {
          Swal.fire("", "ไม่พบข้อมูลรายการอะไหล่", "warning");
        }
      })
      .catch(error => {
        console.error('Error loading material options:', error);
      });
    },
    loadMaterialOptions() {
      axios.post("/Api/QIJobs/ProductOption", {
        page: 0,
        limit: 1000,
        optionWithCode: true,
        qiTypes: ['QiSpare']
      })
      .then((response) => {
        if (response.status === 200) {
          this.originalOptions = response.data.results.map(element => ({
            id: element.id,
            text: element.text,
            data: element.data
          }));
          this.updateSelect2Options();
        }
      })
      .catch(error => {
        console.error('Error loading material options:', error);
      });
    },
    updateSelect2Options() {
      const usedCodes = this.recvitems.map(item => item.MaterialCode);
      const availableOptions = this.originalOptions.filter(option => !usedCodes.includes(option.id));
      this.odcMaterialCodeOptions = {
        data: availableOptions,
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
      };
    },
    getMaterialCodeOptions(index) {
      const selectedCodes = this.recvitems.map((item, idx) => idx !== index ? item.MaterialCode : null).filter(code => code);
      return {
        data: this.originalOptions.filter(option => !selectedCodes.includes(option.id)),
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
      };
    },
    onMaterialCodeChange(index) {
      const materialCode = this.recvitems[index].MaterialCode;
      if (!materialCode) return;

      const selectedItem = this.originalOptions.find(item => item.id === materialCode);
      if (selectedItem) {
        this.$set(this.recvitems[index], 'MaterialName', selectedItem.text);
        this.$set(this.recvitems[index], 'UnitName', selectedItem.data.baseUnit);
        this.$set(this.recvitems[index], 'UnitPrice', selectedItem.data.qiPrice);
      } else {
        console.warn('Item not found in originalOptions');
      }
    },
    editReferenceCode() {
      this.refCode = "";
      this.recvitems = [];
      this.isReferenceCodeLocked = false;
    }
  },
  mounted() {
    this.loadMaterialOptions();
    $(this.$refs.form).validate({
      rules: {
        refCode: "required",
      },
      messages: {
        refCode: "กรุณาระบุ เลขที่ใบเบิกสินค้า",
      },
    });
  },
  watch: {
    recvitems: {
      deep: true,
      handler(newValue, oldValue) {
        newValue.forEach((item, index) => {
          // ตรวจสอบ MaterialCode
          if (item.MaterialCode) {
            this.$set(this.errors, index, { ...this.errors[index], materialCode: '' });
          }
          // ตรวจสอบ Quantity
          if (item.Quantity && item.Quantity > 0) {
            this.$set(this.errors, index, { ...this.errors[index], quantity: '' });
          }
        });
      }
    }
  }
};
</script>
<style lang="css">
.select2-container {
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// App/Components/QIJob/QIRecvBorrow.vue